<template>
  <div>
    <div class="card">
      <div class="card-header py-2">
        <Spinner v-if="loading" margin_right="10px" height="20px" />
        <b-form-checkbox v-else class="display-inline marginright5" v-model="checkedAllBdl"></b-form-checkbox>
        <span @click="checkedAllBdl = !checkedAllBdl">BDL</span>
        <div style="float: right;">
          <span id="bdl-label-color" :style="{ display: 'inline-block', width: '18px', height: '18px', borderRadius: '50%', backgroundColor: bdlLabelColorCss, cursor: 'pointer', border: '2px solid #ccc', marginRight: '6px', verticalAlign: 'middle' }"></span>
          <b-popover target="bdl-label-color" triggers="focus" placement="top">
            <template v-slot:title>Label color</template>
            <SketchPicker
              v-model="bdlLabelColor"
              :presetColors="bdlLabelPresetColors"
              :disableAlpha="true"
              :disableFields="true"
            />
          </b-popover>
          <img @click="expanded = !expanded" style="height: 13px; cursor: pointer;" :src="expanded ? icons.chevronUp : icons.chevronDown" />
        </div>
      </div>
      <div class="card-body" v-if="expanded">
        <b-form-checkbox class="display-inline marginright5" v-model="active"></b-form-checkbox>
        <span @click="active = !active">Active</span>
        <b-form-checkbox class="display-inline marginright5" v-model="inactive"></b-form-checkbox>
        <span @click="inactive = !inactive">Inactive</span>
        <div class="bdl-filter-controls">
          <button type="button" class="btn btn-sm btn-outline-secondary" @click="openBdlFilterModal">Filter</button>
          <button v-if="bdlFilter" type="button" class="btn btn-sm btn-outline-secondary" @click="resetBdlFilter">Reset</button>
          <span v-if="bdlFilter" class="bdl-filter-summary">{{ bdlFilterSummary }}</span>
        </div>
        <div class="bdl-plot-count">Wyświetlane działki: {{ visiblePlotCount }} z {{ bdlPlots.length }}</div>
      </div>
    </div>
    <div ref="bdlFilterModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="bdlFilterTitle" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="bdlFilterTitle" class="modal-title">Filtr działek leśnych</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Zamknij"></button>
          </div>
          <div class="modal-body">
            <div class="bdl-filter-grid">
              <label>
                <span>Piętro</span>
                <select v-model="filterDraft.storeys" class="form-select" multiple size="6">
                  <option v-for="option in storeyOptions" :key="option.value" :value="option.value">{{ option.value }} ({{ option.count }})</option>
                </select>
              </label>
              <label>
                <span>Gatunek</span>
                <select v-model="filterDraft.species" class="form-select" multiple size="6">
                  <option v-for="option in speciesOptions" :key="option.value" :value="option.value">{{ option.value }} ({{ option.count }})</option>
                </select>
              </label>
              <label>
                <span>Udział od</span>
                <select v-model="filterDraft.partFrom" class="form-select">
                  <option v-for="option in participationFromOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                </select>
              </label>
              <label>
                <span>Udział do</span>
                <select v-model="filterDraft.partTo" class="form-select">
                  <option v-for="option in participationToOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                </select>
              </label>
              <label>
                <span>Wiek od</span>
                <input v-model.number="filterDraft.ageFrom" type="number" min="1" step="1" class="form-control" />
              </label>
              <label>
                <span>Wiek do</span>
                <input v-model.number="filterDraft.ageTo" type="number" min="1" step="1" class="form-control" />
              </label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="applyBdlFilter">Zastosuj</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .bdl-filter-controls {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
  }

  .bdl-filter-summary,
  .bdl-plot-count {
    font-size: 12px;
  }

  .bdl-plot-count {
    margin-top: 6px;
  }

  .bdl-filter-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(110px, 1fr));
    gap: 10px;
  }

  .bdl-filter-grid label {
    min-width: 0;
    font-weight: 600;
  }

  .bdl-filter-grid label > span {
    display: block;
    margin-bottom: 5px;
  }

  .bdl-filter-grid select[multiple] {
    min-height: 144px;
  }

  @media (max-width: 900px) {
    .bdl-filter-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  :deep(.bdl-popup .leaflet-popup-content-wrapper) {
    padding: 0;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.17);
  }

  :deep(.bdl-popup .leaflet-popup-content) {
    width: 760px !important;
    max-width: min(760px, 72vw) !important;
    margin: 0 !important;
    padding: 0;
    box-sizing: border-box;
    overflow: visible !important;
  }

  :deep(.bdl-popup .leaflet-popup-content-wrapper) {
    overflow: visible !important;
  }

  :deep(.bdl-popup .leaflet-popup-tip) {
    background: white;
  }

  :deep(.bdl-popup-pwa .leaflet-popup-content) {
    width: min(88vw, 420px) !important;
    max-width: min(88vw, 420px) !important;
    max-height: 55vh;
    overflow: auto !important;
  }

  :deep(.bdl-popup-pwa .leaflet-popup-content-wrapper) {
    max-width: 92vw;
  }

  :global(.bdl-label) {
    background: transparent;
    border: 0;
    border-radius: 0;
    width: 0;
    height: 0;
  }

  :global(.bdl-label-text) {
    color: #111;
    display: block;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.2;
    padding: 0;
    position: absolute;
    left: 0;
    top: 0;
    transform: translate(-50%, -50%);
    white-space: pre-line;
  }

  @media (max-width: 900px) {
    :deep(.bdl-popup .leaflet-popup-content) {
      width: min(88vw, 560px) !important;
      max-width: min(88vw, 560px) !important;
    }
  }
</style>

<script lang="ts">
import BaseComponent from './Base.vue';
import { EventBus } from '@/ts/EventBus';
import { AlertStatus, DownloadStatus } from '@/ts/types';
import { defineComponent } from "vue";

export default defineComponent({
    extends: BaseComponent,
    data() {
        const checkedAllBdl: boolean = false;

        return {
            checkedAllBdl,
            loading: false,
            expanded: false,
            active: true,
          inactive: false,
          bdlCanvasLayer: null as any,
          bdlResults: [] as any[],
          bdlPlots: [] as any[],
          bdlFilter: null as any,
          filterDraft: {
            storeys: ['DRZEW'] as string[],
            species: [] as string[],
            partFrom: '0',
            partTo: '10',
            ageFrom: '',
            ageTo: '',
          }
            ,bdlLabelColor: { r: 17, g: 17, b: 17, a: 1 }
            ,bdlLabelPresetColors: ['#111111', '#FF0000', '#0000FF', '#008000', '#FF8C00', '#800080', '#FFFFFF', '#000000']
        };
    },
      computed: {
        bdlLabelColorCss(): string {
          const color: any = this.bdlLabelColor;
          if (typeof color === 'string') return color;
          if (color && color.hex) return color.hex;
          if (color && color.rgba) {
            return `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${color.rgba.a ?? 1})`;
          }
          if (color && color.r !== undefined) {
            return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a ?? 1})`;
          }
          return '#111111';
        },
      storeyOptions(): Array<{ value: string; count: number }> {
        return this.getCountedDetailOptions('storey_cd');
      },
      speciesOptions(): Array<{ value: string; count: number }> {
        return this.getCountedDetailOptions('species_cd');
      },
      nonNumericPartValues(): string[] {
        const values = new Set<string>();
        for (const plot of this.bdlResults) {
          for (const row of this.getLayerSpecies(plot?.details)) {
            const value = this.getDetailCode(row?.part_cd);
            if (value && !this.isNumericValue(value)) values.add(value);
          }
        }
        return Array.from(values).sort((left, right) => left.localeCompare(right));
      },
      participationFromOptions(): Array<{ value: string; label: string }> {
        const options = Array.from({ length: 10 }, (_, index) => {
          const value = String(10 - index);
          return { value, label: value };
        });
        if (this.nonNumericPartValues.length) {
          options.push({ value: '__NON_NUMERIC__', label: this.nonNumericPartValues.join('/') });
        }
        options.push({ value: '0', label: '0' });
        return options;
      },
      participationToOptions(): Array<{ value: string; label: string }> {
        const options = Array.from({ length: 10 }, (_, index) => {
          const value = String(10 - index);
          return { value, label: value };
        });
        if (this.nonNumericPartValues.length) {
          options.push({ value: '__NON_NUMERIC__', label: this.nonNumericPartValues.join('/') });
        }
        return options;
      },
      bdlFilterSummary(): string {
        if (!this.bdlFilter) return '';
        const describe = (values: string[]) => values.length ? values.join(', ') : 'dowolne';
        const describeBound = (value: string) => value === '__NON_NUMERIC__' ? this.nonNumericPartValues.join('/') : value || 'brak';
        return `Piętro: ${describe(this.bdlFilter.storeys)}; gatunek: ${describe(this.bdlFilter.species)}; udział: ${describeBound(this.bdlFilter.partFrom)}–${describeBound(this.bdlFilter.partTo)}; wiek: ${this.bdlFilter.ageFrom || 'brak'}–${this.bdlFilter.ageTo || 'brak'}`;
      },
      visiblePlotCount(): number {
        if (!this.checkedAllBdl) return 0;
        return this.bdlPlots.filter((plot: any) => {
          const statusVisible = plot.is_active ? this.active : this.inactive;
          return statusVisible && this.matchesBdlFilter(plot);
        }).length;
      }
    },
    created() {
      EventBus.$on('downloadExternalData', () => this.downloadBdl());
      EventBus.$on('toggleBdl', () => {
        if (this.$options.result) {
          this.checkedAllBdl = !this.checkedAllBdl;
        }
      });
      EventBus.$on('selectedAreaChanged', (newArea: string, oldArea: string) => this.onSelectedAreaChanged(newArea, oldArea));
      EventBus.$on('mapReady', this.onMapReady);
    },
    mounted() {
      this.onMapReady();
    },
    beforeUnmount() {
      EventBus.$off('mapReady', this.onMapReady);
      if (this.bdlCanvasLayer && window.mainmap) {
        this.bdlCanvasLayer.removeFrom(window.mainmap);
        this.bdlCanvasLayer = null;
      }
    },
    methods: {

      onMapReady() {
        if (!window.mainmap) return;
        if (this.checkedAllBdl) this.ensureBdlCanvasLayer();
        this.redrawBdlLabels();
      },

      ensureBdlCanvasLayer() {
        if (!window.mainmap || this.bdlCanvasLayer) return;
        // @ts-ignore L.CanvasLayer is registered by main.ts.
        this.bdlCanvasLayer = L.canvasLayer().delegate(this);
        this.bdlCanvasLayer.addTo(window.mainmap);
        if (this.bdlCanvasLayer._canvas) {
          this.bdlCanvasLayer._canvas.style.pointerEvents = 'none';
        }
      },

      redrawBdlLabels() {
        if (this.bdlCanvasLayer) this.bdlCanvasLayer.needRedraw();
      },

      isPointInSelectedArea(lat: number | string, lon: number | string) {
        // @ts-ignore
        const areaKey = window.selectedArea;
        if (!areaKey) return true;
        // @ts-ignore
        const area = window.areas[areaKey];
        if (!area || !area[0] || !area[1]) return true;
        const minLat = Math.min(area[0][0], area[1][0]);
        const maxLat = Math.max(area[0][0], area[1][0]);
        const minLon = Math.min(area[0][1], area[1][1]);
        const maxLon = Math.max(area[0][1], area[1][1]);
        const plat = Number(lat);
        const plon = Number(lon);
        if (Number.isNaN(plat) || Number.isNaN(plon)) return false;
        return (plat >= minLat && plat <= maxLat && plon >= minLon && plon <= maxLon);
      },

      extractBdlPolygonParts(points: any): any[] {
        if (!Array.isArray(points) || !points.length) return [];
        const first = points[0];
        if (Array.isArray(first) && first.length && Array.isArray(first[0]) && first[0].length >= 2 && typeof first[0][0] === 'number') {
          return points;
        }
        if (Array.isArray(first) && first.length >= 2 && typeof first[0] === 'number' && typeof first[1] === 'number') {
          return [points];
        }
        return [];
      },

      isPathInSelectedArea(path: any[]) {
        if (!path || !path.length) return false;
        const flattened: Array<[number, number]> = [];
        const walk = (value: any) => {
          if (Array.isArray(value)) {
            if (value.length >= 2 && typeof value[0] === 'number' && typeof value[1] === 'number') {
              flattened.push([value[0], value[1]]);
              return;
            }
            for (const item of value) {
              walk(item);
            }
          }
        };
        walk(path);
        return flattened.some(([lat, lon]) => this.isPointInSelectedArea(lat, lon));
      },

      parseDetails(value: any) {
        if (!value) return null;
        if (typeof value === 'string') {
          try {
            return JSON.parse(value);
          } catch (e) {
            return null;
          }
        }
        return value;
      },
      getLayerSpecies(details: any) {
        const parsedDetails = this.parseDetails(details);
        const layerSpecies = Array.isArray(parsedDetails)
          ? parsedDetails
          : parsedDetails?.layerSpecies;
        if (!Array.isArray(layerSpecies)) return [];
        return layerSpecies.map((row: any) => {
          if (Array.isArray(row)) {
            return {
              storey_cd: row[0],
              species_cd: row[1],
              part_cd: row[2],
              species_age: row[3],
            };
          }
          return row;
        });
      },
      getDetailCode(value: any): string {
        return String(value ?? '').split(':', 1)[0].trim();
      },
      isNumericValue(value: any): boolean {
        return String(value ?? '').trim() !== '' && Number.isFinite(Number(value));
      },
      getCountedDetailOptions(field: string): Array<{ value: string; count: number }> {
        const counts = new Map<string, number>();
        for (const plot of this.bdlResults) {
          for (const row of this.getLayerSpecies(plot?.details)) {
            const value = this.getDetailCode(row?.[field]);
            if (value) counts.set(value, (counts.get(value) || 0) + 1);
          }
        }
        return Array.from(counts, ([value, count]) => ({ value, count }))
          .sort((left, right) => right.count - left.count || left.value.localeCompare(right.value));
      },
      createDefaultBdlFilter(): { storeys: string[]; species: string[]; partFrom: string; partTo: string; ageFrom: string; ageTo: string } {
        return { storeys: ['DRZEW'], species: [], partFrom: '0', partTo: '10', ageFrom: '', ageTo: '' };
      },
      openBdlFilterModal() {
        this.filterDraft = this.bdlFilter
          ? { ...this.bdlFilter, storeys: [...this.bdlFilter.storeys], species: [...this.bdlFilter.species] }
          : this.createDefaultBdlFilter();
        this.openModal(this.$refs.bdlFilterModal as HTMLElement);
      },
      applyBdlFilter() {
        this.bdlFilter = {
          ...this.filterDraft,
          storeys: [...this.filterDraft.storeys],
          species: [...this.filterDraft.species],
        };
        this.closeModal(this.$refs.bdlFilterModal as HTMLElement);
        this.onCheckedAllBdlChanged();
      },
      resetBdlFilter() {
        this.bdlFilter = null;
        this.onCheckedAllBdlChanged();
      },
      getComparableNumber(value: any, emptyValue: number): number {
        const normalized = this.getDetailCode(value);
        if (!normalized) return emptyValue;
        return this.isNumericValue(normalized) ? Number(normalized) : 0.5;
      },
      matchesBdlFilter(plot: any): boolean {
        if (!this.bdlFilter) return true;
        const filter = this.bdlFilter;
        const rows = this.getLayerSpecies(plot?.details);
        return rows.some((row: any) => {
          const storey = this.getDetailCode(row?.storey_cd);
          const species = this.getDetailCode(row?.species_cd);
          const selectedStorey = !filter.storeys.length || filter.storeys.includes(storey);
          const selectedSpecies = !filter.species.length || filter.species.includes(species);
          const part = this.getComparableNumber(row?.part_cd, 0);
          const partFrom = filter.partFrom === '__NON_NUMERIC__' ? 0.5 : this.getComparableNumber(filter.partFrom, 0);
          const partTo = filter.partTo === '__NON_NUMERIC__' ? 0.5 : this.getComparableNumber(filter.partTo, 10);
          const age = this.getComparableNumber(row?.species_age, 0);
          const ageFrom = this.getComparableNumber(filter.ageFrom, 0);
          const ageTo = this.getComparableNumber(filter.ageTo, 1000000);
          return selectedStorey && selectedSpecies
            && part >= partFrom && part <= partTo
            && age >= ageFrom && age <= ageTo;
        });
      },
      escapeHtml(value: any) {
        return String(value ?? '').replace(/[&<>"']/g, (char) => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[char as keyof Record<string, string>] || char));
      },
      buildBdlPopupHtml(responseTour: any) {
        const rows = this.getLayerSpecies(responseTour?.details);
        if (!rows.length) {
          return '<div style="font-size: 12px;">Brak danych</div>';
        }

        const columns = [
          ['storey_cd', 'Warstwa'],
          ['species_cd', 'Gatunek'],
          ['part_cd', 'Udział'],
          ['species_age', 'Wiek'],
        ];
        const headerHtml = '<tr>' + columns.map((column) => {
          return '<th style="padding: 8px 10px; border: 1px solid #d7d7d7; background: #f4f4f4; font-weight: 700; text-align: left; white-space: nowrap;">'
            + this.escapeHtml(column[1])
            + '</th>';
        }).join('') + '</tr>';

        const rowsHtml = rows.map((row: any) => {
          const cells = columns.map((column) => {
            const value = row?.[column[0]] ?? '';
            const displayValue = typeof value === 'string'
              ? value.replace(/:.*/, '')
              : value;
            return '<td style="padding: 8px 10px; border: 1px solid #d7d7d7; vertical-align: top; word-break: break-word;">'
              + this.escapeHtml(displayValue)
              + '</td>';
          }).join('');
          return '<tr>' + cells + '</tr>';
        }).join('');

        return '<div class="bdl-popup-content" style="width: 100%; max-width: 760px; font-size: 12px; line-height: 1.35; padding: 4px; box-sizing: border-box;">'
          + '<table style="border-collapse: separate; border-spacing: 0; width: 100%; table-layout: fixed; border: 1px solid #cfcfcf; min-width: 100%;">'
          + '<thead>' + headerHtml + '</thead>'
          + '<tbody>' + rowsHtml + '</tbody>'
          + '</table></div>';
      },
      getBdlLabelText(responseTour: any, zoom: number) {
        const treeRows = this.getLayerSpecies(responseTour?.details).filter((row: any) => {
          const layer = row?.storey_cd;
          return typeof layer === 'string' && layer.split(':', 1)[0] === 'DRZEW';
        });
        if (!treeRows.length) return '';

        const maxRows = zoom >= 18 ? treeRows.length : zoom >= 17 ? 3 : zoom >= 16 ? 2 : zoom >= 15 ? 1 : 0;
        if (!maxRows) return '';

        const getDisplayValue = (value: any) => typeof value === 'string' ? value.replace(/:.*/, '') : value ?? '';
        const rowsToDisplay = treeRows.slice(0, maxRows);
        return rowsToDisplay.map((row: any) => {
          const species = getDisplayValue(row.species_cd);
          const part = getDisplayValue(row.part_cd);
          const age = getDisplayValue(row.species_age);
          return rowsToDisplay.length >= 2 ? `${species}:${part}:${age}` : `${species}:${age}`;
        }).join('\n');
      },
      onDrawLayer(info: any) {
        const ctx = info.canvas.getContext('2d');
        if (!ctx) return;
        ctx.clearRect(0, 0, info.canvas.width, info.canvas.height);

        const zoom = Math.floor(info.zoom);
        if (!this.checkedAllBdl || zoom < 15) return;

        ctx.font = '700 12px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = this.bdlLabelColorCss;

        const drawnLabels = new Set<string>();
        for (const polygon of this.$options.cycleways || []) {
          if (!window.mainmap.hasLayer(polygon)) continue;
          const labelCoords = (polygon as any).bdlLabelCoords;
          if (!labelCoords || !info.bounds.contains(labelCoords)) continue;

          const labelText = this.getBdlLabelText((polygon as any).bdlResponseTour, zoom);
          if (!labelText) continue;
          const labelKey = `${labelCoords[0]}:${labelCoords[1]}:${labelText}`;
          if (drawnLabels.has(labelKey)) continue;
          drawnLabels.add(labelKey);

          const point = info.layer._map.latLngToContainerPoint(labelCoords);
          const lines = labelText.split('\n');
          const lineHeight = 14;
          const startY = point.y - ((lines.length - 1) * lineHeight) / 2;
          for (let index = 0; index < lines.length; index += 1) {
            ctx.fillText(lines[index], point.x, startY + index * lineHeight);
          }
        }
      },

      updateBdlLabels() {
        this.redrawBdlLabels();
      },
      onSelectedAreaChanged(newArea: string, oldArea: string) {
        if (this.$options.cycleways) {
          for (const segment of this.$options.cycleways) {
            try { segment.removeFrom(window.mainmap); } catch (e) {}
          }
        }
        if (this.$options.result) {
          this.processBdl();
        }
      },
        downloadBdl() {
            this.loading = true;
            const endPoint = window.apiHost + 'api/stringfield/bdl/';
            this.downloadUrlWithCache(endPoint, 'bdl', 'bdl.txt', null, true).then((response) => {
              this.$options.result = response[1].results;
              this.bdlResults = response[1].results;
              if (response[0] == DownloadStatus.cache_fresh) {
                this.createAlert(AlertStatus.success, this.$t('toursLoaded', [response[1].results.length]).toString(), 2000);
              }
              if (response[0] == DownloadStatus.api_fresh) {
                this.createAlert(AlertStatus.success, this.$t('toursDownloaded', [response[1].results.length]).toString(), 2000);
              }
              if (response[0] == DownloadStatus.cache_last) {
                this.createAlert(AlertStatus.warning, this.$t('toursLoaded', [response[1].results.length]).toString(), 2000);
              }
            }).catch((error) => {
              this.createAlert(AlertStatus.danger, this.$t('toursError').toString(), 2000);
            }).finally(() => {
              this.loading = false;
            });
        },
        processBdl() {
            const tours: any[] = [];
            const plots: any[] = [];
            for (const responseTour of this.bdlResults) {
              const polygonParts = this.extractBdlPolygonParts(responseTour['points']);
              if (!polygonParts.length || !this.isPathInSelectedArea(responseTour['points'])) {
                continue;
              }
              plots.push(responseTour);

              for (const polygonPoints of polygonParts) {
                const polygon = new L.Polygon(polygonPoints, {
                  color: 'red',
                  fillColor: 'red',
                  fillOpacity: 0,
                  weight: 2,
                  opacity: 1,
                  interactive: !window.isPwa,
                });

                const popupHtml = this.buildBdlPopupHtml(responseTour);
                if (popupHtml && !window.isPwa) {
                  const isNarrowViewport = window.innerWidth <= 900;
                  polygon.bindPopup(popupHtml, {
                    maxWidth: isNarrowViewport ? Math.min(window.innerWidth * 0.88, 560) : 760,
                    minWidth: isNarrowViewport ? 0 : 560,
                    className: isNarrowViewport ? 'bdl-popup bdl-popup-pwa' : 'bdl-popup',
                    autoPan: true,
                    keepInView: true,
                  });
                  polygon.on('click', () => {
                    try { polygon.openPopup(); } catch (e) {}
                  });
                }

                const labelCoords = responseTour.label;
                const labelText = this.getBdlLabelText(responseTour, 18);
                if (labelText && Array.isArray(labelCoords) && labelCoords.length >= 2
                  && Number.isFinite(Number(labelCoords[0])) && Number.isFinite(Number(labelCoords[1]))) {
                  (polygon as any).bdlResponseTour = responseTour;
                  (polygon as any).bdlLabelCoords = [Number(labelCoords[0]), Number(labelCoords[1])];
                }

                polygon.on('mouseover', () => {
                  polygon.setStyle({'color': 'yellow', 'fillColor': 'yellow', 'fillOpacity': 0});
                  polygon.bringToFront();
                });
                polygon.on('mouseout', () => {
                  polygon.setStyle({'color': 'red', 'fillColor': 'red', 'fillOpacity': 0});
                });

                polygon.is_active = responseTour.is_active;
                tours.push(polygon);
              }
            }
            this.bdlPlots = plots;
            this.$options.cycleways = tours;
            this.onCheckedAllBdlChanged();
            this.redrawBdlLabels();
        },
        onCheckedAllBdlChanged() {
            if (this.$options.cycleways) {
              if (this.checkedAllBdl) {
                this.ensureBdlCanvasLayer();
              } else if (this.bdlCanvasLayer) {
                this.bdlCanvasLayer.removeFrom(window.mainmap);
                this.bdlCanvasLayer = null;
              }
              for(const segment of this.$options.cycleways) {
                if (this.checkedAllBdl) {
                  if (!this.matchesBdlFilter(segment.bdlResponseTour)) {
                    segment.removeFrom(window.mainmap);
                  } else if (segment.is_active) {
                    if (this.active) {
                      segment.addTo(window.mainmap);
                    } else {
                      segment.removeFrom(window.mainmap);
                    }
                  } else {
                    if (this.inactive) {
                      segment.addTo(window.mainmap);
                    } else {
                      segment.removeFrom(window.mainmap);
                    }
                  }
                } else {
                  segment.removeFrom(window.mainmap);
                }
              }
              this.redrawBdlLabels();
            } else {
              this.processBdl();
            }
        }
    },
    watch: {
        "checkedAllBdl": [{
            handler: "onCheckedAllBdlChanged"
        }],
        "active": [{
            handler: "onCheckedAllBdlChanged"
        }],
        "inactive": [{
            handler: "onCheckedAllBdlChanged"
        }],
        "bdlLabelColor": [{
          handler: "updateBdlLabels"
        }]
    }
})

</script>
